var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import FilterContext from '@jetshop/core/components/Filters/FilterContext';
import stripCategoryId from '@jetshop/core/components/Filters/utils/stripCategoryId';
import { ListItem, StyledCarrot, StyledCheck } from '@jetshop/ui/Select/Components';
import { css } from 'emotion';
import React, { useContext } from 'react';
import styled from 'react-emotion';
const Wrapper = styled(ListItem) ``;
const Carrot = styled(StyledCarrot) `
  margin-right: 0px;
`;
/** Shows the filter name along with a check if the filter is active */
const FilterName = function FilterName(_a) {
    var { accordionProps, idx, filter } = _a, rest = __rest(_a, ["accordionProps", "idx", "filter"]);
    const filterContext = useContext(FilterContext);
    // get the filterType from the GraphQL typename field.
    // Remove 'Numeric' from the NumericRangeFilter type.
    const filterType = filter.__typename.replace('Numeric', ''); // e.g. ListFilter, RangeFilter
    const filterTypePlural = filterType.charAt(0).toLowerCase() + filterType.slice(1) + 's'; // e.g. listFilters, rangeFilters
    const isActive = filterContext.activeFilters[filterTypePlural].some((f) => f.id === stripCategoryId(filter.id));
    return (React.createElement(Wrapper, Object.assign({ onClick: () => accordionProps.handleClick(idx) }, rest, { "data-filter-accordion-button": "", "data-filter-accordion-button-active": isActive }),
        filter.name,
        isActive ? (React.createElement(StyledCheck, { className: css `
            margin-right: 0;
          ` })) : (React.createElement(Carrot, { open: accordionProps.openIndexes.includes(idx) }))));
};
export { FilterName };
//# sourceMappingURL=FilterAccordion.js.map